export default "__VITE_ASSET__BzFSa5be__"